<template>
  <div></div>
</template>

<script>
import PalletModel from "@/models/Pallet3D.js";
import Helper from "@/models/Helper.js";
export default {
  props: {
    pallet: {
      required: true,
      type: Object
    }
  },
  data() {
    return {};
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      await Helper.timeout(50);
      const palletModel = new PalletModel(this.pallet);
      palletModel.x;
    }
  }
};
</script>

<style scoped>
body {
  margin: 0;
  height: 100vh;
}

canvas {
  display: block;
}
</style>